import IconWrapper from "../IconWrapper/IconWrapper";
import { FiltroStatusEmail } from "core/features/relatorios/typings";

interface FiltroTagEmailProps {
  selectedTipoEmail?: string;
  setSelectedTipoEmail: (selected: any) => any;
}
function FiltroTagEmail({
  selectedTipoEmail,
  setSelectedTipoEmail,
}: FiltroTagEmailProps) {
  const data = [
    { id: FiltroStatusEmail.Todos, nome: "Todos" },
    { id: FiltroStatusEmail.Lidos, nome: "Lidos" },
    { id: FiltroStatusEmail.NaoLidos, nome: "Não lidos" },
    { id: FiltroStatusEmail.Enviados, nome: "Enviados" },
    { id: FiltroStatusEmail.NaoEnviados, nome: "Não enviados" },
    { id: FiltroStatusEmail.Erro, nome: "Erro" },
  ];

  const onSelectTipoEmail = (t: string) => {
    setSelectedTipoEmail(selectedTipoEmail === t ? undefined : t);
  };

  return (
    <>
      {data?.map((i) => (
        <IconWrapper
          key={i.id}
          onClick={() => {
            onSelectTipoEmail?.(i.id);
          }}
          selected={selectedTipoEmail === i.id}
        >
          {i.nome}
        </IconWrapper>
      ))}
    </>
  );
}

export default FiltroTagEmail;
